// extracted by mini-css-extract-plugin
export default {"backButton":"styles_backButton__fizns","infoTitle":"styles_infoTitle__FuqjX","sectionMargins":"styles_sectionMargins__TVZu3"};